import ViewSupply from "./ViewSupply";
export default ViewSupply;